import { useEffect, useState , useRef} from "react";
import "../../assets/Css/notifications.css";
import CloseIcon from "../../assets/images/Synchro/close_24.svg";
import ReportIcon from "../../assets/images/Synchro/report_icon.svg";
import io from "socket.io-client";
import config  from "../../config";

// console.log("KAFKA",process.env.REACT_APP_KAFKA_CONNECTION);
// const socket =  io(String(process.env.REACT_APP_KAFKA_CONNECTION), {
//     path: "/kafkaservice"
//   });

function NotificationsHolder() {

    const [notifications, setNotifications] = useState([]);
    const wsRef = useRef(null);
    const [topic, setTopic] = useState("traffic_alerts_routes_athens");

    useEffect(() => {
        console.log("Connecting to WebSocket...",config.KAFKA_CONNECTION);
        const ws = new WebSocket(config.KAFKA_CONNECTION);
        wsRef.current = ws;
    
        ws.onopen = () => {
          console.log("✅ WebSocket connected");
          ws.send(`subscribe:${topic}`);
        };
    
        ws.onmessage = (event) => {
          try {
            console.log("Received message:", event.data);
            // Assuming the message is a JSON string containing an array of alerts
            // Adjust the parsing logic based on your actual message format
            console.log("typeof:", typeof event.data);
            const msg = JSON.parse(event.data);
            setNotifications((prev) => [...prev, msg]);
          } catch (err) {
            console.error("Failed to parse message:", err);
          }
        };
    
        ws.onclose = () => console.warn("❌ WebSocket disconnected");
    
        return () => {
          ws.close();
        };
      }, [topic]);

    const dismissNotification = (position) => {
        setNotifications(prevItems => prevItems.filter((_, index) => index !== position));
    };
    return (
        <div className="notifications-container">
            {notifications.map((notif, key) => (
                <div className="notification-card" key={key}>
                    <div className="notification-header">
                        <img src={ReportIcon} />
                        <h4 className="notification-title">{notif.title} - route id: {notif.route_id}</h4>
                        <img src={CloseIcon} className="dismiss-btn" onClick={() => dismissNotification(key)} />
                    </div>
                    <p className="notification-body">{notif.body}</p>
                    <div className="notification-footer">
                        <span className="notification-date">{new Date().toLocaleString('en-US')}</span>
                        <div className="notification-actions">
                            <button className="action-btn">View</button>
                            <button className="action-btn-dissmiss" onClick={() => dismissNotification(key)}>Ignore</button>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default NotificationsHolder;